<template>
  <div class="column-sort" ref="dropdownRef">
    <button
      class="button button--filter column-sort__toggle"
      type="button"
      :aria-expanded="isOpen"
      :aria-controls="menuId"
      @click="toggleDropdown">
      <span>Sortera efter</span>
      <span class="column-sort__icon icon icon--arrow-down" :class="{ 'column-sort__icon--open': isOpen }" aria-hidden="true"></span>
    </button>
    <div :id="menuId" class="column-sort__menu" v-show="isOpen">
      <label
        class="column-sort__option"
        v-for="option in sortOptions"
        :key="option.key">
        <input
          type="radio"
          :name="radioName"
          :value="option.key"
          v-model="selectedKey"
          @change="applySort"
        />
        <span class="icon icon--radiounchecked"></span>
        <span class="icon icon--radiochecked"></span>
        <span class="column-sort__label">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { useSearch } from "@/services/search-service";
import { useStore } from "@/stores/store";

const store = useStore();
const { sortSearchResult } = useSearch();

const props = defineProps<{
  radioName: string;
}>();

const isOpen = ref(false);
const menuId = computed(() => `${props.radioName}-menu`);
const dropdownRef = ref<HTMLElement | null>(null);
const selectedKey = ref<string | null>(store.sorting.dataKey ?? null);

const sortOptions = [
  { key: "name", label: "Namn", ascending: true },
  { key: "navalBattles", label: "Sjöslag", ascending: true },
  { key: "type", label: "Typ", ascending: true },
  { key: "suspension", label: "Avslut", ascending: false },
  { key: "length", label: "Storlek", ascending: false },
];

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const applySort = () => {
  if (!selectedKey.value) {
    return;
  }
  const option = sortOptions.find((item) => item.key === selectedKey.value);
  const ascending = option ? option.ascending : true;
  store.sorting.dataKey = selectedKey.value;
  store.sorting.descending = !ascending;
  sortSearchResult(selectedKey.value, ascending);
  store.currentPage = 0;
  /* isOpen.value = false; */
};

watch(
  () => store.sorting.dataKey,
  (newKey) => {
    selectedKey.value = newKey ?? null;
  },
);

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node | null;
  if (target && dropdownRef.value && !dropdownRef.value.contains(target)) {
    isOpen.value = false;
  }
};

const handleEscape = (event: KeyboardEvent) => {
  if (event.key === "Escape") {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside, true);
  document.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside, true);
  document.removeEventListener("keydown", handleEscape);
});
</script>
